import React from "react";
import { Column, Columns} from "@dna/react";
import {PatientSearchResult} from "../../../services/medicationmanagement/patientApi/models/PatientSearchResult";
import {UserType} from "../../../services/medicationmanagement/medsUser/MedsUserApi";
import {ReactComponent as Ascending} from "../../../images/sort-ascending.svg";
import {RenderIf} from "../../common/render-if/RenderIf";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box as Mbox} from "@material-ui/core";
import classes from './ResidentTable.module.scss';
import { ResidentTableRow } from "./resident-table-row/ResidentTableRow";

const HeaderFormatter = (props:{label:string, showSorting:boolean}) => {
            return (
                <Columns
                    css={{
                        gap: props.showSorting? "small":"0"
                    }}
                >
                    <Column width="content">{props.label}</Column>
                    <RenderIf if={props.showSorting}>
                        <Column width="content">
                            <Ascending />
                        </Column>
                    </RenderIf>
                </Columns>
            );
    
};

export interface IResidentTableProps {
  residents: PatientSearchResult[];
  userType: UserType;
  loading?: boolean;
  createUrl: (item: PatientSearchResult, userType: UserType) => string;
}

export const ResidentTable = (props: IResidentTableProps) => {
    let { residents, loading, createUrl, userType } = props;
    return (
        <TableContainer>
            <Table className={classes.fixed}>
                <col style={{width: "30%"}} />
                <col style={{width: "20%"}} />
                <col style={{width: "10%"}} />
                <col style={{width: "12%"}} />
                <TableHead>
                    <TableRow role="header">
                        <TableCell
                            align={"left"}
                            className={classes.header}
                        >
                            <HeaderFormatter label="Resident" showSorting={
                                userType===UserType.Doctor
                            }/>
                        </TableCell>
                        <TableCell
                            align={"left"}
                            className={classes.header}
                        >Organisation &amp; facility</TableCell>
                        <TableCell
                            align={"left"}
                            className={classes.header}
                        >
                            <HeaderFormatter label="Chart updated" showSorting={userType===UserType.Pharmacist} />
                        </TableCell>
                        <TableCell
                            align={"left"}
                            className={classes.header}
                        >Chart expiry</TableCell>
                        <TableCell
                            align={"left"}
                            className={classes.header}
                        >Status</TableCell>
                        <TableCell
                            align={"left"}
                            className={classes.header}
                        >Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody className={classes.residentTable}>
                    <RenderIf if={!loading}>
                        <>
                            {(residents||[]).map(data=>{
                                return <ResidentTableRow key={data.id} data ={data} userType = {userType}></ResidentTableRow>
                            })}
                        </>
                    </RenderIf>
                    
                </TableBody>
            </Table>
        </TableContainer>
    );
}
